import { createClient } from '@supabase/supabase-js';

import type { Database } from './types/database';

export const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL || 'https://kdjrlcktnkbjeqhbvmgl.supabase.co';
const SUPABASE_ANON_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_HJr3CeuC7_a6Wu2KFwjXqA_Dw4fosBA';

// Client typé : chaque requête (.from('table')…) connaît les colonnes réelles de la base.
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY);
